import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const includeNewMoscowTagManager = createBooleanTagManager({
  jsonQueryKey: 'include_new_moscow',
  trueLabel: 'Новая Москва',
  falseLabel: 'Без Новой Москвы',
  id: 'includeNewMoscow',
});
